
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle'

import '../style/index.css';
import '../style/bootstrap-lumen.css';
import '../Content/bootstrap-lumen.css';
import '../Content/bootstrap-theme.css';
//import '../style/bootstrap-lumen.css';
import '../Content/bootstrap-datepicker3.css';
import '../Content/bootstrap-select.min.css';
import '../Content/DataTables/css/dataTables.bootstrap.css';
import '../Content/toastr.css';
import '../Content/ej2/material.css';
import '../Content/Site.css';

import Account from './Account/Account';
import AccountEdit from './Account/AccountEdit';
import AccountNew from './Account/AccountNew';

import Component from './Component/Component';
import ComponentEdit from './Component/ComponentEdit';
import ComponentNew from './Component/ComponentNew';

import ComponentCategory from './ComponentCategory/ComponentCategory';
import ComponentCategoryEdit from './ComponentCategory/ComponentCategoryEdit';
import ComponentCategoryNew from './ComponentCategory/ComponentCategoryNew';

import Country from './Country/Country';
import CountryEdit from './Country/CountryEdit';
import CountryNew from './Country/CountryNew';

import Customer from './Customer/Customer';
import CustomerEdit from './Customer/CustomerEdit';
import CustomerNew from './Customer/CustomerNew';

import DesignEdit from './Design/DesignEdit';

import DesignFolder from './DesignFolder/DesignFolder';
import DesignFolderDetails from './DesignFolder/DesignFolderDetails';
import DesignFolderNew from './DesignFolder/DesignFolderNew';

import DesignPrint from './DesignPrint/DesignPrint';

import EntryFactor from './EntryFactor/EntryFactor';
import EntryFactorEdit from './EntryFactor/EntryFactorEdit';
import EntryFactorNew from './EntryFactor/EntryFactorNew';

import Industry from './Industry/Industry';
import IndustryEdit from './Industry/IndustryEdit';
import IndustryNew from './Industry/IndustryNew';

import MaterialHandled from './MaterialHandled/MaterialHandled';
import MaterialHandledEdit from './MaterialHandled/MaterialHandledEdit';
import MaterialHandledNew from './MaterialHandled/MaterialHandledNew';

import Navbar from './Page/Navbar';
import NotFound from './Page/NotFound';

import SchematicDraw from './Schematic/SchematicDraw';

import Sites from './Sites/Sites';
import SitesEdit from './Sites/SitesEdit';

import State from './State/State';
import StateEdit from './State/StateEdit';
import StateNew from './State/StateNew';

import ChangePassword from './_Login/ChangePassword';
import Eductor from './Eductor/Eductor';
import EductorDetails from './Eductor/EductorDetails';
import EductorTests from './Eductor/EductorTests';
import EductorNew from './Eductor/EductorNew';
import EductorPrint from './Eductor/EductorPrint';
import EductorBlank from './Eductor/EductorBlank';

import { createContext, useState } from 'react';
import TokenLogin from './_Login/TokenLogin';

import { Toaster } from 'react-hot-toast';
import Oilers from './Oilers/Pages/Oilers';
import OilersNew from './Oilers/Pages/OilersNew';
import OilerDetails from './Oilers/Pages/OilerDetails';
import OilerConfiguration from './Oilers/Pages/OilerConfiguration';
import OilerConfigurationNew from './Oilers/Pages/OilerConfigurationNew';
import OilerConfigurationTests from './Oilers/Pages/OilerConfigurationTests';
import OilerConfigrationPrint from './Oilers/Pages/OilerConfigurationPrint';
import Oils from './Oils/Pages/OilerOils';
import OilDetails from './Oils/Pages/OilerOilDetails';
import OilsNew from './Oils/Pages/OilerOilsNew';
import OilerConfigrationBlank from './Oilers/Pages/OilerConfigurationBlank';
import OilerTestDiagrams from './Oilers/Pages/OilerTestDiagrams';
import Choppers from './Choppers/Pages/Choppers';
import ChoppersNew from './Choppers/Pages/ChoppersNew';
import ChoppersDetail from './Choppers/Pages/ChoppersDetail';
import Cyclones from './Cyclones/Pages/Cyclones';
import CyclonesDetail from './Cyclones/Pages/CyclonesDetail';
import CyclonesNew from './Cyclones/Pages/CyclonesNew';
import EductorTests2 from './Eductor/EductorTests2';


export const UserContext = createContext();

function App() {

  const [user, setUser] = useState({});

  return (
    <>
      <UserContext.Provider value={[user, setUser]}>

        <div>
          <Toaster />
        </div>

        <Router>
          <div className="App">
            <header className="App-header mon_group">
              <Navbar />
            </header>

            <div className="content mon_group">
              <Routes>

                {user["email"] != undefined && <Route exact path="/" element={<DesignFolder />} />}
                {user["email"] == undefined && <Route exact path="/" element={<TokenLogin />} />}

                <Route exact path="/Login" element={<TokenLogin />} />

                <Route exact path="/Design" element={<DesignFolder />} />
                <Route exact path="/DesignFolder" element={<DesignFolder />} />
                <Route exact path="/DesignFolder/details/:id" element={<DesignFolderDetails />} />
                <Route exact path="/DesignFolder/New" element={<DesignFolderNew />} />

                <Route exact path="/Design/Edit/:id" element={<DesignEdit />} />
                <Route exact path="/Design/Print/:id" element={<DesignPrint />} />

                <Route exact path="/Customer" element={<Customer />} />
                <Route exact path="/Customer/Edit/:id" element={<CustomerEdit />} />
                <Route exact path="/Customer/New" element={<CustomerNew />} />

                <Route exact path="/Sites" element={<Sites />} />
                <Route exact path="/Sites/Edit/:id" element={<SitesEdit />} />

                <Route exact path="/State" element={<State />} />
                <Route exact path="/State/Edit/:id" element={<StateEdit />} />
                <Route exact path="/State/New" element={<StateNew />} />

                <Route exact path="/Country" element={<Country />} />
                <Route exact path="/Country/Edit/:id" element={<CountryEdit />} />
                <Route exact path="/Country/New" element={<CountryNew />} />

                <Route exact path="/MaterialHandled" element={<MaterialHandled />} />
                <Route exact path="/MaterialHandled/Edit/:id" element={<MaterialHandledEdit />} />
                <Route exact path="/MaterialHandled/New" element={<MaterialHandledNew />} />

                <Route exact path="/Account" element={<Account />} />
                <Route exact path="/Account/Edit/:id" element={<AccountEdit />} />
                <Route exact path="/Account/New" element={<AccountNew />} /> 
                <Route exact path="/ChangePassword" element={<ChangePassword />} />

                <Route exact path="/Industry" element={<Industry />} />
                <Route exact path="/Industry/Edit/:id" element={<IndustryEdit />} />
                <Route exact path="/Industry/New" element={<IndustryNew />} />

                <Route exact path="/EntryFactor" element={<EntryFactor />} />
                <Route exact path="/EntryFactor/Edit/:id" element={<EntryFactorEdit />} />
                <Route exact path="/EntryFactor/New" element={<EntryFactorNew />} />

                <Route exact path="/Component" element={<Component />} />
                <Route exact path="/Component/Edit/:id" element={<ComponentEdit />} />
                <Route exact path="/Component/New" element={<ComponentNew />} />

                <Route exact path="/ComponentCategory" element={<ComponentCategory />} />
                <Route exact path="/ComponentCategory/Edit/:id" element={<ComponentCategoryEdit />} />
                <Route exact path="/ComponentCategory/New" element={<ComponentCategoryNew />} />

                <Route exact path="/Schematic/Draw/:id" element={<SchematicDraw />} />

                <Route exact path="/Eductor" element={<Eductor />} />
                <Route exact path="/Eductor/Details/:id" element={<EductorDetails />} />
                {/* <Route exact path="/Eductor/Tests/:id" element={<EductorTests />} /> */}
                <Route exact path="/Eductor/Tests/:id" element={<EductorTests2 />} />
                <Route exact path="/Eductor/New" element={<EductorNew />} />
                <Route exact path="/Eductor/Details/Print/:id" element={<EductorPrint />} />
                <Route exact path="/Eductor/Blank" element={<EductorBlank />} />

                <Route exact path="/Oilers" element={<Oilers />} />
                <Route exact path="/Oilers/TestDiagrams" element={<OilerTestDiagrams />} />
                <Route exact path="/Oilers/Details/:id" element={<OilerDetails />} />
                <Route exact path="/Oilers/New" element={<OilersNew />} />
                <Route exact path="/Oilers/Configuration/:id" element={<OilerConfiguration />} />
                <Route exact path="/Oilers/Configuration/:id/Tests" element={<OilerConfigurationTests />} />
                <Route exact path="/Oilers/Configuration/:id/Print" element={<OilerConfigrationPrint />} />
                <Route exact path="/Oilers/Configuration/Blank" element={<OilerConfigrationBlank />} />
                <Route exact path="/Oilers/Details/:id/NewConfiguration" element={<OilerConfigurationNew />} />

                <Route exact path="/Oils" element={<Oils />} />
                <Route exact path="/Oils/Details/:id" element={<OilDetails />} />
                <Route exact path="/Oils/New" element={<OilsNew />} />                

                <Route exact path="/Choppers" element={<Choppers />} />
                <Route exact path="/Choppers/Details/:id" element={<ChoppersDetail />} />
                <Route exact path="/Choppers/New" element={<ChoppersNew />} />                

                <Route exact path="/Cyclones" element={<Cyclones />} />
                <Route exact path="/Cyclones/Details/:id" element={<CyclonesDetail />} />
                <Route exact path="/Cyclones/New" element={<CyclonesNew />} />

                <Route path="*" element={<NotFound />} />

              </Routes>
            </div>
          </div>
        </Router>

      </UserContext.Provider>
    </>
  );
}

export default App;